import React, { useState, useEffect } from 'react';
import config from "config";
import Spinner from 'NOTICEBOARD/CommonResources/SpinnerLoader/Spinner';
import NoticeboardAPICall from 'NoticeboardAPICall';
import { CalendarTodayOutlined, KeyboardArrowDownOutlined, Bookmark, SummarizeOutlined, Workspaces, GridViewOutlined, AttachFileOutlined, CheckOutlined, ShareOutlined, VisibilityOutlined, FiberManualRecord, FormatListBulletedOutlined, AccessTimeOutlined, WindowOutlined } from '@mui/icons-material';
import Avatar from '@mui/material/Avatar';
import Popover from '@mui/material/Popover';
import { LinkOutlined, Instagram, Twitter, WhatsappOutlined, Telegram, FacebookOutlined, History, Close, ArrowBack } from '@mui/icons-material';
import 'NOTICEBOARD/Components/NoticeboardDashbard/NoticeboardDashbard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Pagination } from '@mui/material';
import NoticeView from '../Notices/NoticeView/NoticeView';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import SuccessModal from 'NOTICEBOARD/CommonResources/SuccessModal/SuccessModal';
import dummyNoticeImage from 'NOTICEBOARD/Components/NoticeboardDashbard/Image/dummyNoticeImage.png';
import Snackbar from '@mui/material/Snackbar';
import ButtonLoader from 'NOTICEBOARD/CommonResources/ButtonLoader/ButtonLoader';
import { ToastContainer, toast } from "react-toastify";
import copy from 'copy-to-clipboard';
import "react-toastify/dist/ReactToastify.css";
import ReactHtmlParser from 'react-html-parser';

function NoticeboardDashbard() {
    // api path
    let apiPathGetNoticeList = '/api/notice/notice.php';
    let apiPathGetIndividualNoticeDetails = '/api/notice/notice.php';

    // css styling
    let styles = {
        iconStyle: {
            color: '#828282',
            fontSize: '20px',
            marginRight: "5px",
        },

        dotIconStyle: {
            color: '#BDBDBD',
            fontSize: '10px',
            marginLeft: '5px'
        },

        bookmarkChecked: {
            color: '#FF9900'
        },

        bookmarkUnchecked: {
            color: '#828282',
        },

        bookMarkStatusCheck: {
            color: '#FF9900'
        },

        bookMarkStatusUncheck: {
            color: '#828282'
        },

        unreadNoticeUnchecked: {
            color: '#828282',
        },

        unreadNoticeChecked: {
            color: '#0465AC'
        },

        buttonDivStyle: {
            color: '#828282',
            fontSize: '12px',
            marginRight: '5px',
            padding: '5px',
            textAlign: 'center',
            background: 'white',
            cursor: 'pointer',
        },

        activeButtonDivStyle: {
            color: 'white',
            backgroundColor: '#0465AC',
            fontSize: '12px',
            marginRight: '5px',
            padding: '5px',
            textAlign: 'center',
            cursor: 'pointer',
        },

        popoverTextTitle: {
            width: '37%',
            borderRadius: '5px',
            padding: '2px',
            fontSize: 'small',
            color: 'rgba(0, 0, 0, 0.8)',
        },

        popoverInput: {
            border: '1px solid rgba(4, 101, 172, 0.7)',
            padding: '2px',
            fontSize: '12px',
            color: 'rgba(0, 0, 0, 0.4)',
        }
    }

    // states for noticelist
    const [noticeList, setNoticeList] = useState({});
    const [noticeSequence, setNoticeSequence] = useState([]);
    const [noticeTitle, setNoticeTitle] = useState('');
    const [filterApplied, setFilterApplied] = useState(false);
    const [filterDayType, setFilterDays] = useState('');
    const [filterFromDate, setFilterFormDate] = useState('');
    const [filterToDate, setFilterEndDate] = useState('');
    const [isDateSelected, setIsDateSelected] = useState(false);
    const [filterTitle, setFilterNoticeTitle] = useState('');
    const [dataFetching, setDataFetching] = useState(false);

    const [filterCategory, setFilterNoticeCategory] = useState('');
    const [searchCategory, setSearchCategory] = useState('');
    const [isCategorySelected, setIsCategorySelected] = useState(false);

    let apiPathCategoryList = "/api/notice/category.php";
    const [categoryList, setCategoryList] = useState({});
    const [categoryFetching, setCategoryFetching] = useState(false);

    const [filterPostedBy, setFilterPostedBy] = useState('');
    const [searchPostedBy, setSearchPostedBy] = useState('');
    const [isPostedBySelected, setIsPostedBySelected] = useState(false);

    const [filterBookmark, setFilterNoticeBookmark] = useState(false);
    const [filterUnread, setFilterUnreadNotice] = useState(false);
    const [pageIndex, setPageIndex] = useState(1);
    const [noticeLimit, setNoticeLimit] = useState(20);
    const [noticePagination, setNoticePagination] = useState({
        pageIndex: 1,
        limit: 20
    });

    const [showSideBarNoticeView, setShowSideBarNoticeView] = useState(false);
    const [noticeViewObject, setNoticeViewObject] = useState({});

    const [successModalDetails, setSuccessModalDetails] = useState({
        successModal: false,
        successModalType: '',
        successMessage: ''
    });

    const [totalCount, setTotalCount] = useState(0);
    const [getIndividualNoticeDetails, setGetIndividualNoticeDetails] = useState({});
    const [dataFetchingGetIndividualNoticeDetails, setIndividualNoticeFetching] = useState(false);


    const [getFacultyList, setGetFacultyList] = useState({});
    const [fetchingFacultyList, setFetchingFacultyList] = useState(false);
    const [offset, setOffset] = useState(0);
    const [activePage, setActivePage] = useState(1);
    const [limit, setLimit] = useState(100);

    // state for search by category
    const [showModalReadUnreadStatus, setShowModalReadUnreadStatus] = useState(false);
    const [showModalHistory, setShowModalHistory] = useState(false);
    const [shareNotice, setShareNotice] = useState(false);
    const [noticePublicLink, setNoticePublicLink] = useState('');
    const [noticeLinkTitle, setNoticeLinkTitle] = useState('');
    const [copyLinkMessage, setCopyLinkMessage] = useState('');

    const [deviceWidth, setDeviceWidth] = useState('');
    const [isGrid, setIsGrid] = useState(true);


    //popover for select category
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [anchorElCategory, setAnchorElCategory] = React.useState(null);
    const [anchorElPostedBy, setAnchorElPostedBy] = React.useState(null);

    const open = Boolean(anchorEl);
    const openCategory = Boolean(anchorElCategory);
    const openPostedBy = Boolean(anchorElPostedBy);

    const idSearchByDate = open ? 'simple-popover' : undefined;
    const idCategory = openCategory ? 'simple-popover' : undefined;
    const idPostedBy = openPostedBy ? 'simple-popover' : undefined;

    // METHOD FOR SEARCH BY DATE 
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    // METHOD FOR SEARCH CATEGORY 
    const handleClickCategory = (event) => {
        setAnchorElCategory(event.currentTarget);
    };

    // METHOD FOR CLOSE SEARCH CATEGORY MODAL
    const handleCloseCategoryModal = () => {
        setAnchorElCategory(null);
    };


    // METHOD FOR SEARCH SEARCH CATEGORY 
    const handleClickPostedBy = (event) => {
        setAnchorElPostedBy(event.currentTarget);
    };

    // METHOD FOR CLEAR SEARCH CATEGORY MODAL
    const handleClosePostedByModal = () => {
        setFilterPostedBy('');
        setSearchPostedBy('');
        setIsPostedBySelected(false);
        setAnchorElPostedBy(null);
        setNoticeList({});
        setNoticeSequence([]);
        setFilterApplied(false);
        setNoticePagination({
            pageIndex: 1,
            limit: 20
        });
    };
    
    // METHOD FOR CLEAR SEARCH CATEGORY 
    const handleCloseCategory = () => {
        setFilterNoticeCategory('');
        setSearchCategory('');
        setIsCategorySelected(false);
        setAnchorElCategory(null);
        setNoticeList({});
        setNoticeSequence([]);
        setFilterApplied(false);
        setNoticePagination({
            pageIndex: 1,
            limit: 20
        });
    };

    // METHOD TO CLEAR FILTER NOTICE
    const closeFilterNotice = () => {
        setFilterPostedBy('');
        setSearchPostedBy('');
        setIsPostedBySelected(false);
        setAnchorElPostedBy(null);

        setFilterNoticeCategory('');
        setSearchCategory('');
        setIsCategorySelected(false);
        setAnchorElCategory(null);

        setIsDateSelected(false);
        setFilterNoticeTitle('');
        setFilterDays('');
        setFilterFormDate('');
        setFilterEndDate('');
        setFilterFormDate('');
        setFilterUnreadNotice(false);
        setFilterNoticeBookmark(false);
        setNoticeList({});
        setNoticeSequence([]);
        setFilterApplied(false);
        setNoticePagination({
            pageIndex: 1,
            limit: 20
        });
    }


    // // METHOD FOR  GET NOTICE LIST API CALL 
    // useEffect(() => {
    //     getNoticeList();
    // }, [noticePagination]);

    // METHOD FOR FILTER NOTICES API CALL 
    useEffect(() => {
        getNoticeList();
    }, [noticePagination, filterDayType, filterBookmark, filterUnread]);

    // METHOD TO CLOSE SUCCESS MODAL
    const closeSuccessModal = () => {
        setSuccessModalDetails({
            successModal: false,
            successModalType: "",
            successMessage: ""
        });
    }

    //METHOD FOR LOAD MORE DATA
    const getNoticeListLoadMore = () => {
        setNoticePagination({
            pageIndex: noticePagination.pageIndex + 1,
            limit: 20
        });
    }

    // show side bar of notice view
    const showSideBarNoticeViewMethod = (noticeId, readStatus) => {
        apiCallToGetIndividualNotice(noticeId);
        if (readStatus == "false") {
            apiCallToUpdateNoticeUnread(noticeId);
        }

        setShowSideBarNoticeView(true);
    }


    // METHOD FOR BOOKMARK NOTICE
    const apiCallToChangeBookmarkStatus = async (noticeId, bookmarkStatus) => {
        let formData = {
            institute_id: config.institute_id,
            notice_id: noticeId,
            user_id: config.faculty_id,
            bookmark: (bookmarkStatus == 'true' ? 'false' : 'true')
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "bookmarkNotice",
            formData,
            apiPathGetNoticeList
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToChangeBookmarkStatus(noticeId, bookmarkStatus);
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                let noticeListDetails = noticeList;
                if (apiResult.status == "success") {
                    noticeListDetails[noticeId].bookmarkStatus = (bookmarkStatus == 'true' ? 'false' : "true");
                    toast(apiResult.message, {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setNoticeList({ ...noticeListDetails });
                } else {
                    toast(apiResult.message, {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } else {
                toast("Something went wrong while changing bookmark status. Please try again later.", {
                    position: "top-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    };

    // FUNCTION FOR GET INDIVIDUAL NOTICE DETAILS API CALL
    const apiCallToGetIndividualNotice = async (noticeId) => {
        setIndividualNoticeFetching(true);
        let formData = {
            institute_id: config.institute_id,
            notice_id: noticeId,
            user_id: config.faculty_id,
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "getIndividualNoticeDetails",
            formData,
            apiPathGetIndividualNoticeDetails
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToGetIndividualNotice(noticeId);
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                setGetIndividualNoticeDetails(apiResult);
                setIndividualNoticeFetching(false);
            } else {
                setIndividualNoticeFetching(false);
            }
        }
    }

    // METHOD FOR BOOKMARK NOTICE
    const apiCallToUpdateNoticeUnread = async (noticeId, readStatus) => {
        let formData = {
            institute_id: config.institute_id,
            notice_id: noticeId,
            user_id: config.faculty_id,
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "updateNoticeReadStatus",
            formData,
            apiPathGetNoticeList
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                apiCallToUpdateNoticeUnread(noticeId, readStatus);
            }, 1000);
        } else {
            if (jsonResponse.success) 
            {
                let apiResult = jsonResponse.APIResult;
                let noticeListDetails = noticeList;
                if (apiResult.status == "success") 
                {
                    noticeListDetails[noticeId].readStatus = "true";
                    setNoticeList({ ...noticeListDetails });
                    toast.success(apiResult.message, {
                        toastId: 'success1',
                    });
                } 
                else{
                    toast.warn(apiResult.message);
                }
            } 
            else 
            {
                toast.warning("Something went wrong while changing read status. Please try again later.")
            }
        }
    };

    // METHOD FOR GET NOTICE LIST API CALL
    const getNoticeList = async () => {
        if (Object.keys(noticeList).length == 0) {
            setDataFetching(true);
        }

        let formData = {
            institute_id: config.institute_id,
            user_id: config.faculty_id,
            page_index: noticePagination.pageIndex,
            limit: noticePagination.limit,
            filter_title: filterTitle,
            filter_category: filterCategory,
            filter_from_date: filterFromDate,
            filter_to_date: filterToDate,
            filter_unread: filterUnread,
            filter_bookmark: filterBookmark,
            filter_day_type: filterDayType,
            filter_added_by: '',
            filter_posted_by_id_array: filterPostedBy ? [filterPostedBy] : [],
            user_role: config.userRole,
        };

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            "getNoticeListOnDashBoard",
            formData,
            apiPathGetNoticeList
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                getNoticeList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                setTotalCount(jsonResponse.APIResult.totalCount);

                let sortedIdArray = noticeSequence.concat(jsonResponse.APIResult.sequenceIdArray);
                let noticeDetails = Object.assign(noticeList, apiResult);
                
                setNoticeSequence(sortedIdArray);
                setNoticeList(noticeDetails);
                setDataFetching(false);
            } else {
                setDataFetching(false);
            }
        }
    };

    // METHOD FOR BOOKMARK NOTICE
    const bookmarkNotice = (noticeId, bookmarkStatus) => {
        apiCallToChangeBookmarkStatus(noticeId, bookmarkStatus);
    }

    // METHOD FOR SEARCH NOTICE BY TITLE
    const searchByTitle = (e) => {
        setNoticeSequence([]);
        setNoticeList({});
        getNoticeList();
    }

    // METHOD FOR FILTER SEARCH BY DAYS
    const searchByDays = (type) => {
        setNoticeSequence([]);
        setNoticeList({});
        setFilterDays(type);
        setFilterApplied(true);
    }

    // METHOD FOR SEARCH NOTICE DATE   
    const searchByDate = (e) => {
        if (filterFromDate && filterToDate) {
            setIsDateSelected(true);
        }
        else {
            setIsDateSelected(false);
        }
        handleClose();
        setNoticeList({});
        setNoticeSequence([]);
        setFilterApplied(true);
        setNoticePagination({
            pageIndex: 1,
            limit: 20
        });
    }

    // METHOD FOR SEARCH CATEGORY
    const searchCategoryFromAllCategory = (e) => {
        setSearchCategory(e.target.value);
        // getCategoryListAPICall();
    }

    // METHOD FOR SEARCH NOTICE BY CATEGORY   
    const searchByCategory = (e) => {
        if (filterCategory) {
            setIsCategorySelected(true);
        }
        else {
            setIsCategorySelected(false);
        }
        setNoticeList({});
        setNoticeSequence([]);
        setFilterApplied(true);
        setNoticePagination({
            pageIndex: 1,
            limit: 20
        });
        setAnchorElCategory(null);
    }

    // METHOD FOR SEARCH POSTED BY
    const searchPostedByFromAllPostedBy = (e) => {
        setSearchPostedBy(e.target.value);
    }

    // METHOD FOR SEARCH NOTICE BY POSTED BY
    const searchPostedByMethod = (e) => {
        if (filterPostedBy) {
            setIsPostedBySelected(true);
        }
        else {
            setIsPostedBySelected(false);
        }
        setNoticeList({});
        setNoticeSequence([]);
        setFilterApplied(true);
        setNoticePagination({
            pageIndex: 1,
            limit: 20
        });
        setAnchorElPostedBy(null);
    }

    // METHOD TO SEARCH BY BOOKMARK NOTICE
    const searchByBookmarkNotice = (e) => {
        setNoticeSequence([]);
        setFilterApplied(true);
        setNoticePagination({
            pageIndex: 1,
            limit: 20
        });
        setNoticeList({});
        setFilterNoticeBookmark(!filterBookmark);
    }

    // METHOD FOR SEARCH BY UNREAD NOTICE 
    const searchByUnreadNotice = (e) => {
        setNoticeSequence([]);
        setFilterApplied(true);
        setNoticePagination({
            pageIndex: 1,
            limit: 20
        });
        setNoticeList({});
        setFilterUnreadNotice(!filterUnread);
    }

    useEffect(() => {
        setDeviceWidth(window.innerWidth)
    }, [deviceWidth]);

    // calling CategoryListAPI to get category
    useEffect(() => {
        getCategoryListAPICall();
    }, [searchCategory]);

    useEffect(() => {
        getGetFacultyList();
    }, [searchPostedBy]);

    // METHOD TO GET CATEGORY LIST API CALL    
    const getCategoryListAPICall = async () => {
        setCategoryFetching(true);

        let formData = {
            "iid": config.institute_id,
            "offset": '',
            "limit": '',
            "filterCategoryName": searchCategory,
            "filterStatus": ""
        }
        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            'GetNoticeBoardCategoryList',
            formData,
            apiPathCategoryList
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                getCategoryListAPICall();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                setCategoryList(apiResult);
                setCategoryFetching(false);
            } else {
                setCategoryFetching(false);
                // setSuccessModalDetails({
                //     successModal:true,
                //     successModalType:"error",
                //     successMessage:"Something went wrong while getting category list. Please try again later."
                // });
            }
        }

    }

    // METHOD TO GET CATEGORY LIST API CALL    
    const getGetFacultyList = async () => {
        setFetchingFacultyList(true);

        let formData = {
            "iid": config.institute_id,
            "type": "all",
            "page_index": 1,
            "limit": 1000,
            "search": searchPostedBy,
            "status": '0',


        }
        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            'getFacultyList',
            formData,
            '/api/instructor/facultyRegistration.php'
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                getGetFacultyList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                setGetFacultyList(apiResult);
                setFetchingFacultyList(false);
            } else {
                setFetchingFacultyList(false);
            }
        }

    }

    // METHOD FOR SEARCH BY NOTICE TITLE 
    const setFilterVariables = () => {
        setNoticeList({});
        setNoticeSequence([]);
        setNoticePagination({
            pageIndex: 1,
            limit: 20
        });
    }

    const stripHtmlEntities = (text) => 
    {
        return text.replace(/<[^>]*>?/gm, '');
    }

    return (
        <>
            <div>
                {/* popover for select date */ }
                <Popover
                    id={ idSearchByDate }
                    open={ open }
                    anchorEl={ anchorEl }
                    onClose={ handleClose }
                    anchorOrigin={ {
                        vertical: 'bottom',
                        horizontal: 'left',
                    } }
                >
                    <div className='p-2' style={ { height: '80px', width: '350px' } }>
                        <div className="row">
                            <div style={ styles.popoverTextTitle }>From</div>
                            <div style={ styles.popoverTextTitle }>To</div>
                            <div ></div>
                            <div style={styles.popoverTextTitle}>
                                <input
                                    value={filterFromDate}
                                    onChange={(e) => { setFilterFormDate(e.target.value) }}
                                    type="date" 
                                    style={styles.popoverInput} 
                                    className='w-100 rounded' 
                                />
                            </div>
                            <div style={styles.popoverTextTitle}>
                                <input
                                    value={filterToDate}
                                    min={filterFromDate}
                                    onChange={(e) => {
                                        setFilterEndDate(e.target.value)

                                    }}
                                    type="date" style={styles.popoverInput} className='w-100 rounded' />
                            </div>
                            <div >
                                <button
                                    onClick={() => searchByDate()}
                                    type="button" className="my-0 smallNormalFont py-1 shadow-none btn btn-primary">
                                    Apply
                                </button>
                            </div>
                        </div>
                    </div>
                </Popover>

                {/* popover for category */ }
                <Popover
                    id={ idCategory }
                    open={ openCategory }
                    anchorEl={ anchorElCategory }
                    // onClose={ handleCloseCategoryModal }
                    anchorOrigin={ {
                        vertical: 'bottom',
                        horizontal: 'left',
                    } }
                >
                    <div className='p-2' style={ { height: '190px', maxWidth: '500px' } } >
                        <div className='scrollController' style={ { height: '80%' } }>
                            <div className='row'><div className='col-12'>
                                <input className='w-100 searchCategoryInput '
                                    placeholder='Search category...' value={ searchCategory }
                                    onKeyPress={ e => {
                                        if (e.charCode === 13) {
                                            searchCategoryFromAllCategory(e);
                                        }
                                    } }
                                    onChange={ (e) => setSearchCategory(e.target.value) } />
                            </div></div>
                            <div className='row col-md-12' style={ { fontSize: '13px' } }>
                                {
                                    Object.keys(categoryList).length > 0 ?
                                        Object.keys(categoryList).map(categoryId => {
                                            return (
                                                <div className='col-6 form-check text-left my-1 categoryFilter-name' title={categoryList[categoryId].title} key={ categoryId }>
                                                    <input
                                                        onChange={ () => setFilterNoticeCategory(categoryId) }
                                                        className="form-check-input"
                                                        name="flexRadioDefault"
                                                        type="radio"
                                                        id="flexCheckDefault"
                                                        checked={ categoryId == filterCategory ? true : false }
                                                    />
                                                    <span className='smallFont secondaryColor'>{ categoryList[categoryId].title }</span>
                                                </div>
                                            );
                                        })
                                    :
                                        <p>No category details found.</p>
                                }
                            </div>
                        </div>
                        <div className="d-flex justify-content-end " style={ { height: '20%' } }>
                            <button
                                onClick={ () => searchByCategory() }
                                type="button" disabled={ filterCategory.length == 0 }  className="py-1 my-1 smallFont  shadow-none btn btn-primary">Apply</button>
                            <button type="button" onClick={ handleCloseCategory } className="py-1 my-1 smallFont btn shadow-none border border-primary text-primary">Clear</button>
                        </div>
                    </div>
                </Popover>

                {/* popover for posted by */ }
                <Popover
                    id={ idPostedBy }
                    open={ openPostedBy }
                    anchorEl={ anchorElPostedBy }
                    // onClose={ handleClosePostedByModal }
                    anchorOrigin={ {
                        vertical: 'bottom',
                        horizontal: 'left',
                    } }
                >
                    <div className='p-2' style={ { height: '190px', maxWidth: '500px' } } >
                        <div className='scrollController' style={ { height: '80%' } }>
                            <div className='row'><div className='col-12'>
                                <input className='w-100 searchCategoryInput '
                                    placeholder='Search faculty...' value={ searchPostedBy }
                                    onKeyPress={ e => {
                                        if (e.charCode === 13) {
                                            searchPostedByFromAllPostedBy(e);
                                        }
                                    } }
                                    onChange={ (e) => setSearchPostedBy(e.target.value) } />
                            </div></div>
                            <div className='row col-md-12' style={ { fontSize: '13px' } }>
                                {
                                    Object.keys(getFacultyList).length > 0 ?
                                        Object.values(getFacultyList).map(faculty => {
                                            return (
                                                <div className='col-6 form-check text-left my-1 postedByName-filter' title={faculty.faculty_fname + ' ' + faculty.faculty_lname} key={ faculty.faculty_id }>
                                                    <input
                                                        onChange={ () => setFilterPostedBy(faculty.faculty_id) }
                                                        className="form-check-input"
                                                        name="flexRadioDefault"
                                                        type="radio"
                                                        id="flexCheckDefault"
                                                        checked={ faculty.faculty_id == filterPostedBy ? true : false }
                                                    />
                                                    <span className='smallFont secondaryColor'>{ faculty.faculty_fname } {faculty.faculty_lname}</span>
                                                </div>
                                            );
                                        })
                                    :
                                        <p>No faculty details found.</p>
                                }
                            </div>
                        </div>
                        <div className="d-flex justify-content-end " style={ { height: '20%' } }>
                            <button
                                onClick={ () => searchPostedByMethod() }
                                type="button" disabled={ filterPostedBy.length == 0 } className="py-1 my-1 smallFont  shadow-none btn btn-primary">Apply</button>
                            <button type="button" onClick={ handleClosePostedByModal } className="py-1 my-1 smallFont btn shadow-none border border-primary text-primary">Clear</button>
                        </div>
                    </div>
                </Popover>
            </div>
            <div className='backgroundColor mb-4'>
                <div className='d-flex col-md-12' >
                    <div className='smallFont secondaryColor flex-grow-1'>
                        <div className="noticeDashboardContainer">
                            <div className='p-0 mx-md-1 '>
                                <input className='w-100 '
                                    style={ { padding: '3px', border: '0.2px solid #BDBDBD', marginRight: "15px" } }
                                    placeholder='Search By Title...' value={ filterTitle }
                                    onKeyPress={ event => {
                                        if (event.charCode === 13) {

                                            setFilterVariables();

                                        }
                                    } }
                                    onChange={ (e) => setFilterNoticeTitle(e.target.value) } />
                            </div>
                            <div className='col-md-3 col-sm-12 p-0 py-2 ml-20 '>
                                <div className='filterByDays'  >
                                    <div
                                        onClick={ () => filterDayType == 'today' ? searchByDays('') : searchByDays('today') } className='w-100' style={ filterDayType === 'today' ? styles.activeButtonDivStyle : styles.buttonDivStyle } >Today</div>
                                    <div
                                        onClick={ () => filterDayType == 'week' ? searchByDays('') : searchByDays('week') } className='w-100' style={ filterDayType === 'week' ? styles.activeButtonDivStyle : styles.buttonDivStyle } >This Week</div>
                                    <div
                                        onClick={ () => filterDayType == 'month' ? searchByDays('') : searchByDays('month') } className='w-100' style={ filterDayType === 'month' ? styles.activeButtonDivStyle : styles.buttonDivStyle } >This Month</div>
                                </div>
                            </div>
                            <div className='p-0 py-2'>
                                <div onClick={ handleClick } className={ isDateSelected ? 'activeDateFilter pointer p-1' : 'pointer p-1' } >Select Date<CalendarTodayOutlined className={ isDateSelected ? 'activeIconStyle mx-2' : 'iconStyle mx-2' } /></div>
                            </div>
                            <div onClick={ handleClickCategory } className='p-0 ml-1'>
                                <div className={ isCategorySelected ? 'activeSearchCategory' : 'searchCategory' }>
                                    <div className='pointer'>Search By Category</div>
                                    <KeyboardArrowDownOutlined className='mx-1' />
                                </div>
                            </div>
                            <div onClick={ handleClickPostedBy } className='p-0 ml-1'>
                                <div className={ isPostedBySelected ? 'activeSearchCategory' : 'searchCategory' }>
                                    <div className='pointer'>Posted by</div>
                                    <KeyboardArrowDownOutlined className='mx-1' />
                                </div>
                            </div>
                            <div className=' pointer' style={ filterUnread ? styles.unreadNoticeChecked : styles.unreadNoticeUnchecked } onClick={ (e) => searchByUnreadNotice(e) }><SummarizeOutlined />Unread</div>
                            <div className='pointer' onClick={ (e) => searchByBookmarkNotice(e) }><Bookmark style={ filterBookmark ? styles.bookmarkChecked : styles.bookmarkUnchecked } />Bookmarked</div>
                            <button className="clear" onClick={ () => closeFilterNotice() } >Clear</button>
                        </div>
                    </div>
                    { deviceWidth > 767 && <div className='p-2 pointer'>{ isGrid ? <FormatListBulletedOutlined onClick={ () => setIsGrid(!isGrid) } style={ styles.iconStyle } /> : <WindowOutlined onClick={ () => setIsGrid(!isGrid) } style={ styles.iconStyle } /> }</div> }
                </div>
                {
                    dataFetching ?
                        <Spinner />
                    :
                        isGrid === true ?
                            <div className='row col-md-12'>
                                {
                                    Object.keys(noticeList).length > 0 ?
                                        noticeSequence.map((noticeId, noticeIndex) => {
                                            let notice = noticeList[noticeId];
                                            let noticeAttachments = notice.attachment == '' ? [] : notice.attachment.split(',');
                                            let description =  ReactHtmlParser(notice.description);
                                            let newString = stripHtmlEntities(notice.description)
                                            return (
                                                <div className='col-md-6 col-sm-12 px-1 my-1 noticeCard'>
                                                    {
                                                        deviceWidth > 767 ?
                                                            <div className="row bg-white p-2">
                                                                <div className='col-2 border p-0' style={{ height: 120 }}>
                                                                    {
                                                                        noticeAttachments.length > 0 ?
                                                                            <>
                                                                                {
                                                                                    (noticeAttachments[0].substring(noticeAttachments[0].lastIndexOf('.') + 1) === 'pdf') ?
                                                                                        <img src={ dummyNoticeImage } height='100%' width='100%' />
                                                                                    :
                                                                                        <img src={ notice.attachmentPath + noticeAttachments[0] } height='100%' width='100%' />
                                                                                }
                                                                            </>
                                                                        :
                                                                            <img src={ dummyNoticeImage } height='100%' width='100%' />
                                                                    }
                                                                </div>
                                                                <div className='col-9 smallFont'>
                                                                    <div className="w-100">
                                                                        <p style={ { fontSize: '14px', color: '#0465AC', fontWeight: 'bold', cursor: "pointer" } } onClick={ () => showSideBarNoticeViewMethod(notice.noticeId, notice.readStatus) } title={ notice.title }>
                                                                            { notice.title.length > 50 ? notice.title.substring(0, 50) + "..." : notice.title }
                                                                        </p>
                                                                        <div className='my-1 d-flex justify-content-between align-items-center' >
                                                                            <div style={ { width: '90%' } } className='text-truncate ' title={ newString }>{ description }</div>
                                                                            <div style={ { fontSize: '14px' } }><AttachFileOutlined style={ { fontSize: '18px' } } />{noticeAttachments.length}</div>
                                                                        </div>
                                                                        <div className='w-100 d-flex'>
                                                                            <div style={ { width: '50%', cursor: "pointer" } } className='text-truncate primaryColor mr-2' onClick={ () => setFilterNoticeCategory(notice.categoryId) }><Workspaces style={ { fontSize: '16px', color: '#BDBDBD', marginRight: '10px' } } />{ notice.categoryName }</div>
                                                                            <div className='text-truncate'>
                                                                                {
                                                                                    notice.department &&
                                                                                        notice.department.split(',').map(department => {
                                                                                            return (
                                                                                                <>
                                                                                                    <FiberManualRecord style={ styles.dotIconStyle } /> { department }
                                                                                                </>
                                                                                            );
                                                                                        })
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        <div className='my-1 d-flex justify-content-between align-items-center' >
                                                                            <div className='MemberIcon'>
                                                                                {typeof notice.addedBy === 'string' && notice.addedBy.split(' ')[0].charAt(0) + notice.addedBy.split(' ')[1].charAt(0) }
                                                                            </div>
                                                                            <div className='noticeMember' >By { notice.addedBy }</div>
                                                                            {
                                                                                (notice.displayOnWebsite == true) &&
                                                                                    <div className="share-notice">
                                                                                        <FontAwesomeIcon icon={['fas', 'share-alt']} style={{ cursor: 'pointer', marginRight: 10, color: 'rgb(130, 130, 130)' }} size="lg" title="Click to share notice" onClick={() => { setShareNotice(true); setNoticePublicLink(notice.PublicLink); setNoticeLinkTitle(notice.title); }} />
                                                                                    </div>
                                                                            }
                                                                            <div>
                                                                                <AccessTimeOutlined style={ styles.iconStyle } className='mx-1' />
                                                                                <span style={ { borderBottom: '1px dashed blue' } }>{ notice.formattedNoticeDate }</span>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-1">
                                                                    <div className='h-100 d-flex justify-content-between align-items-center flex-column'>
                                                                        <Bookmark className='bookMark' style={ notice.bookmarkStatus == 'true' ? styles.bookMarkStatusCheck : styles.bookMarkStatusUncheck } onClick={ () => bookmarkNotice(notice.noticeId, notice.bookmarkStatus) } />
                                                                        {
                                                                            notice.readStatus == "true" ?
                                                                                <DoneAllIcon style={ notice.readStatus ? styles.unreadNoticeChecked : styles.unreadNoticeUnchecked } />
                                                                            :
                                                                                <CheckOutlined style={ notice.readStatus ? styles.unreadNoticeUnchecked : styles.unreadNoticeUnchecked } />
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        :
                                                            <div className='row bg-white smallFont secondaryColor'>
                                                                <div className='col-2 border' style={ { height: '80px' } }>{ noticeIndex }</div>
                                                                <div className='col-10  px-2'>
                                                                    <div className='d-flex'>
                                                                        <div className='flex-grow-1' style={ { fontSize: '14px', color: '#0465AC', fontWeight: 'bold' } }>{ notice.title }</div>
                                                                        <div >
                                                                            <Bookmark style={ notice.bookmarkStatus == 'true' ? styles.bookMarkStatusCheck : styles.bookMarkStatusUncheck } className='mx-2' />
                                                                            {
                                                                                notice.readStatus == "true" ?
                                                                                    <DoneAllIcon style={ notice.readStatus ? styles.unreadNoticeChecked : styles.unreadNoticeUnchecked } />
                                                                                : 
                                                                                    <CheckOutlined style={ notice.readStatus ? styles.unreadNoticeUnchecked : styles.unreadNoticeUnchecked } />
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className='row'>
                                                                        <div className='text-truncate p-0 col-10'>{ notice.description.length > 50 ? `${notice.description.substring(0, 50)}...` : notice.description }</div>
                                                                        <div style={ { fontSize: '14px' } } className='col-2 p-0'><AttachFileOutlined style={ { fontSize: '18px' } } />{ notice.attachment != "" ? 1 : 0 }</div>
                                                                    </div>
                                                                    <div className='col-12 p-0'>
                                                                        <div className='primaryColor mr-2'><Workspaces style={ { fontSize: '16px', color: '#BDBDBD', marginRight: '10px' } } />Extra Curricular</div>
                                                                    </div>
                                                                    <div className='col-12 d-flex p-0'>
                                                                        <div className='text-truncate p-0 col-10'>
                                                                            {
                                                                                notice.department &&
                                                                                    notice.department.split(',').map(department => {
                                                                                        return (
                                                                                            <>
                                                                                                <FiberManualRecord style={ styles.dotIconStyle } /> { department }
                                                                                            </>
                                                                                        );
                                                                                    })
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='col-12 px-1'>
                                                                    <div className='my-1 d-flex justify-content-between align-items-center' >
                                                                        <div className='MemberIcon'>
                                                                            {typeof notice.addedBy === 'string' && notice.addedBy.split(' ')[0].charAt(0) + notice.addedBy.split(' ')[1].charAt(0) }
                                                                        </div>
                                                                        <div className='noticeMember'>By { notice.addedBy }</div>
                                                                        {
                                                                            (notice.displayOnWebsite == true) &&
                                                                                <div className="share-notice">
                                                                                    <FontAwesomeIcon icon={['fas', 'share-alt']} style={{ cursor: 'pointer', marginRight: 10, color: 'rgb(130, 130, 130)' }} size="lg" title="Click to share notice" onClick={() => { setShareNotice(true); setNoticePublicLink(notice.PublicLink); setNoticePublicLink(notice.PublicLink); setNoticeLinkTitle(notice.title); }} />
                                                                                </div>
                                                                        }
                                                                        <div>
                                                                            <AccessTimeOutlined style={ styles.iconStyle } className='mx-1' />
                                                                            <span style={ { borderBottom: '1px dashed blue' } }>{ notice.formattedNoticeDate }</span>
                                                                        </div>
                                                                        <div onClick={ () => setShowModalReadUnreadStatus(true) }><VisibilityOutlined className=' mx-1 primaryColor' />{ notice.assigneeCount }</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                    }
                                                </div>
                                            );
                                        })
                                    :
                                        filterApplied ? 
                                            <div style={ { marginLeft: 14 } }>No notice details found as per applied filter.</div>
                                        :
                                            <div style={ { marginLeft: 14 } }>No notice yet assigned. Please contact administrator for more details.</div>
                                    }
                            </div>
                        :
                            <div className='col-md-12'>
                                {
                                    noticeList &&
                                        Object.keys(noticeList).length !== 0 ?
                                            noticeSequence.map((noticeId, noticeIndex) => {
                                                let notice = noticeList[noticeId];
                                                let noticeAttachments = notice.attachment == '' ? [] : notice.attachment.split(',');
                                                let description =  ReactHtmlParser(notice.description);
                                                let newString = stripHtmlEntities(notice.description)

                                                return (
                                                    <div className="d-flex justify-content-between p-2 mb-2 smallFont  bg-white">
                                                        <div>
                                                            <div style={ { height: '50px', width: '50px', } } className='border'>
                                                                <div>
                                                                    {
                                                                        noticeAttachments.length > 0 ?    
                                                                            <>
                                                                                {
                                                                                    (noticeAttachments[0].substring(noticeAttachments[0].lastIndexOf('.') + 1) === 'pdf') ?
                                                                                        <img src={ dummyNoticeImage } height='100%' width='100%' />
                                                                                    :
                                                                                        <img src={ notice.attachmentPath + noticeAttachments[0] } height='100%' width='100%' />
                                                                                }
                                                                            </>
                                                                        :
                                                                            <img src={ dummyNoticeImage } height='100%' width='100%' />
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div style={ { width: '30%' } } className='d-flex flex-column justify-content-center'>
                                                            <div className='text-truncate primaryColor boldFont' style={ { cursor: "pointer", fontWeight: 'bold' } }
                                                                onClick={ () => showSideBarNoticeViewMethod(notice.noticeId, notice.readStatus) }
                                                                title={ notice.title } >{ notice.title.length > 50 ? `${notice.title.substring(0, 50)}...` : notice.title }</div>
                                                            <div className='text-truncate' title={ newString }>{ description.length > 50 ? `${description.substring(0, 50)}...` : description }</div>
                                                        </div>
                                                        <div className='d-flex align-items-center'>
                                                            <AttachFileOutlined style={ { fontSize: '18px' } } />
                                                            <div style={ { fontSize: '14px' } }>{noticeAttachments.length}</div>
                                                        </div>
                                                        <div style={ { width: '30%' } } className='d-flex flex-column '>
                                                            <div className='primaryColor pointer categoryName-list' title={notice.categoryName} onClick={ () => setFilterNoticeCategory(notice.categoryId) }><Workspaces style={ { fontSize: '16px', color: '#BDBDBD', marginRight: '10px', } } />{ notice.categoryName }</div>
                                                            <div className='text-truncate'>
                                                                {
                                                                    notice.department &&
                                                                    notice.department.split(',').map(department => {
                                                                        return (
                                                                            <>
                                                                                <FiberManualRecord style={ styles.dotIconStyle } /> { department }
                                                                            </>
                                                                        );
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className='d-flex justify-content-center align-items-center'>
                                                            {
                                                                (notice.displayOnWebsite == true) &&
                                                                    <div className="share-notice">
                                                                        <FontAwesomeIcon icon={['fas', 'share-alt']} style={{ cursor: 'pointer', marginRight: 10, color: 'rgb(130, 130, 130)' }} size="lg" title="Click to share notice" onClick={() => { setShareNotice(true); setNoticePublicLink(notice.PublicLink); setNoticePublicLink(notice.PublicLink); setNoticeLinkTitle(notice.title); }} />
                                                                    </div>
                                                            }
                                                            <div className='MemberIcon'>
                                                                { notice.addedBy.split(' ')[0].charAt(0) + notice.addedBy.split(' ')[1].charAt(0) }
                                                            </div>
                                                            <div className='d-flex flex-column mx-2'>
                                                                <div className='noticeMember'>By { notice.addedBy } </div>
                                                                <div>
                                                                    <AccessTimeOutlined style={ styles.iconStyle } />
                                                                    <span style={ { borderBottom: '1px dashed blue' } }>{ notice.formattedNoticeDate }</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="d-flex justify-content-center align-items-center">
                                                            <Bookmark className='bookMark' style={ notice.bookmarkStatus == 'true' ? styles.bookMarkStatusCheck : styles.bookMarkStatusUncheck } onClick={ () => bookmarkNotice(notice.noticeId, notice.bookmarkStatus) } />
                                                        </div>
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            {
                                                                notice.readStatus == "true" ?
                                                                    <DoneAllIcon style={ notice.readStatus ? styles.unreadNoticeChecked : styles.unreadNoticeUnchecked } />
                                                                    :
                                                                    <CheckOutlined style={ notice.readStatus ? styles.unreadNoticeUnchecked : styles.unreadNoticeUnchecked } />
                                                            }
                                                        </div>
                                                    </div>
                                                );
                                            })
                                    :
                                        filterApplied ? 
                                            <div style={ { marginLeft: 14 } }>No notice details found as per applied filter.</div>
                                        :
                                            <div style={ { marginLeft: 14 } }>No notice yet assigned. Please contact administrator for more details.</div>
                                }
                            </div>
                }
                <br/><br/><br/>
                <div>
                    {
                        Object.keys(noticeList).length > 0 && totalCount > 20 &&
                            <div style={{ textAlign: "center", marginTop: 10 }}>
                                <button className="btn primary-button" disabled={Object.keys(noticeList).length == totalCount} onClick={ (e) => getNoticeListLoadMore()}>Load More</button>
                            </div>
                    }
                </div>
                <div className='divPadding' />
            </div>
            {/* modal for share */ }
            {
                shareNotice && 
                    <div>
                        <div className="modal fade show" id="modalContainer"  >
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">

                                    <div className="modal-header d-flex text-center p-2" style={ { backgroundColor: '#0465ac' } } >
                                        <div className=" flex-grow-1">
                                            <p className="modal-title text-white">Share Notice</p>
                                        </div>
                                        <div className="">
                                            <Close style={ { color: 'white', cursor: 'pointer' } } onClick={ () => {
                                                setShareNotice(false);
                                            } } />
                                        </div>
                                    </div>

                                    <div className="modal-body">
                                        {/* <div className='smallFont'>Share this link via</div>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <div className="p-3 border border-primary " style={ { borderRadius: '50px' } }>
                                                <FacebookOutlined />
                                            </div>
                                            <div className="p-3 border border-primary " style={ { borderRadius: '50px' } }>
                                                <Twitter />
                                            </div>
                                            <div className="p-3 border border-primary " style={ { borderRadius: '50px' } }>
                                                <Instagram />
                                            </div>
                                            <div className="p-3 border border-primary " style={ { borderRadius: '50px' } }>
                                                <WhatsappOutlined />
                                            </div>
                                            <div className="p-3 border border-primary " style={ { borderRadius: '50px' } }>
                                                <Telegram />
                                            </div>
                                        </div> */}
                                        <div className='smallFont my-2'>Please use below link for <span style={{ fontWeight: 'bold' }}>{noticeLinkTitle}</span> notice:</div>
                                        <a href={noticePublicLink} target="_blank"><div className='smallFont primaryColor text-truncate'>{noticePublicLink}</div></a>
                                        {
                                            copyLinkMessage != '' &&
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 10 }}>
                                                    <p className="alert alert-success" style={{ padding: 5, width: 'fit-content', fontSize: 12 }}>
                                                        {copyLinkMessage}
                                                        <FontAwesomeIcon icon={['fas', 'times']} style={{ cursor: 'pointer', marginLeft: 5 }} onClick={() => setCopyLinkMessage('')} /> 
                                                    </p>
                                                </div>
                                        }
                                        <div style={{ textAlign: 'right' }}>
                                            <button type="button" className="m-1 py-1 smallFont shadow-none btn btn-primary" onClick={() => { setCopyLinkMessage('URL copied successfully!!'); copy(noticePublicLink); }}>Copy Link</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            }
            {/* sidebar for Notice View */ }
            {
                showSideBarNoticeView &&
                    <NoticeView
                        noticeViewObject={ getIndividualNoticeDetails }
                        setGetIndividualNoticeDetails={ setGetIndividualNoticeDetails }
                        setShowSideBarNoticeView={ setShowSideBarNoticeView }
                        fetchNoticeView={ dataFetchingGetIndividualNoticeDetails }
                    />
            }

            {/* SUCCESS MODAL FOR NOTICE BOARD DASHBOARD  */ }
            {/* {
                successModalDetails.successModal &&
                <SuccessModal
                    successModal={ successModalDetails.successModal }
                    successModalType={ successModalDetails.successModalType }
                    successMessage={ successModalDetails.successMessage }
                    closeSuccessModal={ closeSuccessModal }
                />
            } */}

            {/* RENDER TOAST CONTAINER FOR ADD BOOKMARK  */ }
            {/* {
                <ToastContainer />
            } */}
        </>
    )
}

export default NoticeboardDashbard;
